import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui';
export const Hero = () => {
  return <section className="relative overflow-hidden" data-id="element-5">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-6">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-brand-copper/5 blur-3xl" data-id="element-7"></div>
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-brand-copper/10 blur-3xl" data-id="element-8"></div>
      </div>

      {/* Full-width hero image */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.02
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 1,
      ease: 'easeOut'
    }} className="relative w-full" data-id="element-9">
        <div className="relative w-full max-h-[400px] md:max-h-[550px] lg:max-h-[650px] overflow-hidden" data-id="element-10">
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-brand-cream z-10" data-id="element-11"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qQFgRYiRGxfGjZXNGW3VRK/Gemini_Generated_Image_l8sxcml8sxcml8sx.png" alt="Mujer mirando su cabello dañado frente a una tablet con el método S.O.S. Rescate Capilar" className="w-full h-full object-cover object-center" data-id="element-12" />
        </div>

        {/* Floating badge */}
        
      </motion.div>

      {/* Text content below image */}
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto px-4 pt-8 pb-16 md:pt-12 md:pb-24 text-center z-10 relative" data-id="element-13">
        <div className="inline-block px-4 py-1.5 rounded-full bg-brand-copper/10 border border-brand-copper/20 text-brand-copper font-semibold text-sm tracking-wide uppercase mb-6" data-id="element-14">
          Protocolo de Emergencia
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-playfair font-bold text-brand-brown leading-tight mb-6" data-id="element-15">
          No cortes tu <br className="hidden md:block" data-id="element-16" />
          <span className="text-brand-copper italic" data-id="element-17">cabello todavía.</span>
        </h1>

        <h2 className="text-xl md:text-2xl font-sans text-brand-brownLight font-medium leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-18">
          Recupera tu cabello chicloso o quemado en 7 días — sin salón, sin
          gastar una fortuna, sin cortar nada.
        </h2>

        <p className="text-base md:text-lg text-brand-brown/80 max-w-xl mx-auto mb-10" data-id="element-19">
          El protocolo de rescate capilar que miles de mujeres en Latinoamérica
          necesitan y nadie les había dado.
        </p>

        <CTAButton text="SÍ, QUIERO RESCATAR MI CABELLO AHORA" className="w-full md:w-auto" data-id="element-20" />
      </motion.div>
    </section>;
};